import React,{useState,useEffect} from 'react'
import moment from "moment"
function Day({type, display,updateCalendarDates,currMonth,
    date,dateRange, calendarDates, day}) {
    let dayClassType ="";
    const [status, setStatus] = useState("");
    let displayClass = "", disabled= false;
    useEffect(() => {
        if(type !== "weekNumber"){
            calendarDates.forEach(item => {
                if(item.date === date){
                    if(item.active){
                        setStatus("active");
                    }else {
                        setStatus("");
                    }
                }
            });
        }else {
            if(day.activeWeek){
                setStatus("active")
            }
            else {
                setStatus("")
            }
        }
        
        return () => {
            
        }
    }, [calendarDates])
    if((!moment(date).isBetween(dateRange.date_from, dateRange.date_until,"day","[]")|| 
    !moment(date).isBetween(moment(currMonth).startOf("month"), moment(currMonth).endOf("month"),"day","[]"))
     && type !== "weekNumber"){
        disabled = true;
        displayClass="disabled ";
    }   
    if(type === "weekNumber"){
        dayClassType = "week-number ";
        if(status=== "active"){
            displayClass +="activated-week";
        }
    }else {
        if(status === "active" && disabled ===false ){
            displayClass +="activated-date";
        }
    }
    const handleClick = ()=>{
        if(disabled){
            return;
        }
        console.log("shotgun");
        if(type === "weekNumber"){
            if(status === "active"){
                setStatus("");
                updateCalendarDates(date,"week", false);
            }else {
                setStatus("active");
                updateCalendarDates(date,"week", true);
            }
        }else {
            if(status === "active"){
                setStatus("");
                updateCalendarDates(date,"date", false);
            }else {
                setStatus("active")
                updateCalendarDates(date,"date", true);
                
            }
        }
    }
    return (
        <div className={"calender-date " +dayClassType + displayClass}
         onClick={handleClick}>
            {display}
        </div>
    )
}

export default Day